window.$ = window.jQuery = require('jquery');
import './bootstrap.min.js' ;
import './jquery-validation-1.19.0/dist/jquery.validate.min.js' ;
import './select2.min.js' ;
import '../owlcarousel/owl.carousel.min.js' ;
import "./jquery.nanoscroller.min.js";
import "./jquery.malihu.PageScroll2id.min.js";
import "../code_fun/datepicker/jquery.cookie.min.js";
import "../code_fun/datepicker/jquery.ui.core.js";
import "../code_fun/datepicker/jquery.ui.datepicker-cc.js";
import "../code_fun/datepicker/datepicker-scripts.js";
import "../code_fun/datepicker/datepicker-declarations.js";
import "../code_fun/timepicker/dist/wickedpicker.min.js";
import "./mdtimepicker.min.js";
import "./custom_2.js";


$(document).ready(function () {
    $(".clickOnChilde").click((e) => {
        console.log($(e.currentTarget).parent().parent().children(".megasub_responsive_2").toggleClass("clickOnChilde_active"));
    })
})
